import styled from 'styled-components';
import Banner from '../../assets/Banner.png'

export const Container = styled.main`
  width: 100%;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  padding: 0;

  header {
    height: auto;
    padding: 30px 137px 0 137px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #3FB4A8;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(${Banner});

    div {
      display: flex;
      flex-direction: column;
      width: 100%;
      display: flex;
      align-items: left;
      color: #fff;

      strong {
        padding: 0;
        font-family: Poppins;
        font-size: 68px;
        color: #00314E;
      }

      span {
        color: #fff;
      }
      
      p {
        font-family: Poppins, 'Sans-serif';
        font-size: 15px;
      }
      
      h3 {
        font-family: Poppins, 'Sans-serif';
        font-size: 20px;
        align-items: center;
      }

      button {
        width: 270px;
        padding: 15px 10px;
        margin-bottom: 15px;
        background: #fff;
        border-radius: 15px;
        color: #fff;

        a {
          font-size: 15px;
          font-weight: bold;
          color: #3FB4A8;
        }

        :hover {
          background: #fff9;
          cursor: pointer;
        }
      }
    }

    aside {
      width: 100%;
      height: 100%;
      display: flex;
      margin: 0;
      padding: 0;

      img {
        margin: 0;
        width: 500px;
      }
    }
  };

  content {
    height: auto;
    padding: 0 50px;
    display: flex;
    align-items: center;
    align-content: center;
    margin: 50px 0;
    flex-direction: column;


    div {
      display: flex;
      margin: 10px 0;
      flex-direction: column;
      width: 100%;
      max-width: 1070px;
      display: flex;
      align-items: center;

      img {
        height: 500px;
      }

      h1 {
        font-family: Poppins;
        color: #3FB4A8;
      }

      h3 {
        font-family: Poppins, 'Sans-serif';
        font-size: 20px;
        text-align: center;
      }
      
    }

    aside {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 80%;
      display: flex;
      align-items: left;
      padding: 50px 40px 0 40px;

      h3 {
        padding: 0;
        font-family: Poppins;
        font-weight: normal;
        font-size: 36px;
        padding: 10px 30px 0 20px;
        color: #3FB4A8;
      }
      
      p {
        font-family: Poppins;
        font-size: 15px;
        color: #000;
        padding: 0 50px 0 20px;
      }
    }

  };

  section[id='woman']{
    height: fit-content;
    padding: 0 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;

    div[id='solution'] {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: left;
      color: #000;
      padding: 15 100px;

      span {
        padding: 0 100px 0 0;
        font-family: Poppins;
        font-size: 36px;
      }

      strong {
        color: #14A073;
        font-weight: normal;
      }
      
      p {
        font-family: Poppins, 'Sans-serif';
        font-size: 15px;
      }

    }
  
    aside {
      width: 100%;
      display: flex;
      padding: 0;

      img {
        width: 700px;
      }
    }
  };
`;